module.exports = __webpack_public_path__ + "static/media/amar.7b3098eb.png";